const allCustomOrderColumn = [
  {
    key: 'num',
    label: 'SN.',
  },
  {
    key: 'grandTotal',
    label: 'Amount',
  },
  {
    key: 'name',
    label: 'Order No.',
  },
  {
    key: 'userName',
    label: 'Name',
  },
  {
    key: 'userPhoneNumber',
    label: 'Contact',
  },
  {
    key: 'userEmail',
    label: 'Email',
  },
  {
    key: 'flavors',
    label: 'Flavors',
  },
  {
    key: 'orderStatus',
    label: 'status',
  },

  {
    key: 'actions',
    label: 'Actions',
  },
];
export { allCustomOrderColumn };
